import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import {
  Rol,
  BaseControl,
  Const,
  ConfirmComponent,
  TramiteRol,
  RolTramiteDefaul,
  Categoria,
  Proceso,
  TramiteDefaultCorto
} from '@app/shared';
import { Logger, AuthenticationService } from '@app/core';
import { History } from '@app/flow/flow.component';

import { GroupsPermissionsDataService } from '../shared/groups-permissions.data.service';
import { ManagementGroupsProcessConfigService } from './shared/management-groups-process.config.service';
import { ManagementGroupsProcessDataService } from './shared/management-groups-process.data.service';
import { ManagementGroupsProcessFormsService } from './shared/management-groups-process.form.service';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { Subject } from 'rxjs';

const log = new Logger('ManagementGroupsPermissionComponent');

@Component({
  selector: 'iw-management-groups-process',
  templateUrl: './management-groups-process.component.html',
  styleUrls: ['./management-groups-process.component.scss'],
  providers: [
    GroupsPermissionsDataService,
    ManagementGroupsProcessDataService,
    ManagementGroupsProcessFormsService
  ]
})
export class ManagementGroupsProcessComponent implements OnInit, AfterViewInit, OnDestroy {

  // Historial de las decisiones del usuario en los filtros de las tablas default
  history: History = new History();
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el id del grupo seleccionado
  idTramiteSelect = -1;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene el rol seleccionado
  tramiteRolSelect: TramiteRol;
  // Contiene los roles(Grupos) para listar en el select
  roles: Array<Rol> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene los grupos del tramite
  groups: TramiteRol[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Componente select-tramite
  @ViewChild(SelectTramiteComponent) stcRef: SelectTramiteComponent;

  constructor(
    private gpds: GroupsPermissionsDataService,
    private as: AuthenticationService,
    private toastr: ToastrService,
    private mgppds: ManagementGroupsProcessDataService,
    private mgppfs: ManagementGroupsProcessFormsService,
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.review,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.delete,
    );
    const configTable = new ManagementGroupsProcessConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.value, res.row);
      this.defineActionCondictions('delete', res.row);
    });
    this.gpds.getRoles().subscribe(roles => this.roles = roles);
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  ngAfterViewInit() {
    this.history.active = true;
    // Vigilar los cambios que se producen en los selects de categoria, proceso y tramite.
    this.stcRef.dataObserver.subscribe(change => {
      if (change.target === 'category') {
        this.history.category = change.data as Categoria;
      }
      if (change.target === 'process') {
        this.history.process = change.data as Proceso;
      }
      if (change.target === 'tramite') {
        this.history.tramite = change.data as TramiteDefaultCorto;
      }
    });
  }

  /**
   * Carga los roles(Grupos) asociados al tramite seleccionado
   *
   * @memberof ManagementGroupsProcessComponent
   */
  loadingGroupsTramite() {
    if (this.activateAction.review) {
      this.idTramiteSelect = this.history.tramite.id;
      this.mgppds.getRolesTramites(this.idTramiteSelect).subscribe(groups => {
        if (groups.length) {
          groups.forEach(group => {
            group['nombre'] = group.rol.nombre;
          });
        }
        this.groups = groups;
        this.sourceData = new LocalDataSource(this.groups);
        this.sourceData.refresh();
      });
    } else {
      this.idTramiteSelect = -1;
      this.toastr.error(
        'Usted no posee permisos para ver los grupos asociados a los procesos del sistema',
        'Permiso denegado'
      );
    }
  }

  /**
   * Controla las diferentes acciones a realizar con el rol(Grupo)
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementGroupsProcessComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.backupDataSelectTramiteComponent();
          this.formOpen = true;
          this.actionForm = 'Agregar';
          this.controls = this.mgppfs.getFormRol(this.ngSelectTpl, this.roles);
        } else {
          this.toastr.error(
            'Usted no posee permisos para agregar grupos a los tramites del sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.tramiteRolSelect = data;
          this.question = '¿Realmente desea eliminar el permiso al grupo?';
          this.confirm.open();
        } else {
          this.toastr.error(
            'Usted no posee permisos para eliminar grupos a los tramites del sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  /**
   * Controla la respuesta del modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof ManagementGroupsProcessComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteGroupTramite();
    }
    this.question = '';
  }

  /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof ManagementGroupsProcessComponent
   */
  closeFormRol() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.tramiteRolSelect = null;
  }

  /**
   * Controla el evento de asociar rol(Grupo) a un tramite
   *
   * @param {*} data
   * @memberof ManagementGroupsProcessComponent
   */
  sended(data: any) {
    if (data) {
      let valid = true;
      for (const group of this.groups) {
        if (group.rol.id_rol === data.cboGroup) {
          this.toastr.error(
            'El grupo ' + group.rol.nombre + ' ya se encuentra asociado a el trámite',
            'Permiso denegado'
          );
          valid = false;
          break;
        }
      }
      if (valid) {
        let tramiteRol: RolTramiteDefaul;
        tramiteRol = {
          rol: data.cboGroup,
          tramite_default: this.idTramiteSelect,
          inicio_tramite: data.chInicia
        };
        this.mgppds.addGroupTramite(tramiteRol).then(() => {
          this.loadingGroupsTramite();
          this.closeFormRol();
        });
      }
    }
  }

  /**
   * Elimina un rol(Grupo) de un tramite
   *
   * @private
   * @memberof ManagementGroupsProcessComponent
   */
  private deleteGroupTramite() {
    this.mgppds.deleteGroupTramite(this.tramiteRolSelect.id).then(() => {
      this.loadingGroupsTramite();
      this.closeFormRol();
    }).catch(() => {
      this.closeFormRol();
    });
  }

  /**
   * Guardar copia de los datos de SelectTramiteComponent
   *
   * @private
   * @memberof ManagementGroupsProcessComponent
   */
  private backupDataSelectTramiteComponent() {
    const backup = this.stcRef.getAll();
    for (const key in backup) {
      if (backup.hasOwnProperty(key)) {
        this.history[key] = backup[key];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups-process/management-groups-process.component.ts